module.exports = __webpack_public_path__ + "img/logo-5.8958f54e.png";